import { memo, ReactNode } from 'react'

export type HeaderSharedBlockProps = {
  children: ReactNode
  position?: 'left' | 'right'
}

export const HeaderSharedBlock = memo<HeaderSharedBlockProps>(({ children }) => {
  return <>{children}</>
})

HeaderSharedBlock.displayName = 'HeaderSharedBlock'
